export function usePostFilterForm() {
  function PostsListForm(form) {
    if (!(form instanceof Element)) {
      return;
    }

    // Auto submit when checkbox is changed

    const checkboxGroups = form.querySelectorAll(".post-filter__tax-group");

    function submitForm() {
      form.submit();
    }

    checkboxGroups.forEach((cbg) => {
      const checkboxes = cbg.querySelectorAll('[type="checkbox"]');

      checkboxes.forEach((cb) => {
        cb.addEventListener("change", submitForm);
      });
    });

    // Add clear support for key terms
    const termsGroups = form.querySelectorAll(".post-filter__tags");

    termsGroups.forEach((tg) => {
      const clearButton = tg.querySelector(".post-filter__clear");
      const input = tg.querySelector("input");

      function toggleClearButton() {
        if (input.value) {
          clearButton.classList.remove("hidden");
        } else {
          clearButton.classList.add("hidden");
        }
      }

      function clearInput() {
        input.value = "";
        submitForm();
        clearButton.classList.add("hidden");
      }

      toggleClearButton();

      if (clearButton) {
        clearButton.addEventListener("click", clearInput);
        input.addEventListener("change", toggleClearButton);
      }
    });
  }

  const postFilterForm = document.querySelector(".post-filter__form");

  postFilterForm && PostsListForm(postFilterForm);
}
